import { CACHE_TTL, cache } from '@jucy-nakuru/common/lib/cache';
import { defaultHeadersMiddleware } from '@jucy-nakuru/common/lib/defaultHeadersMiddleware';
import clientConfig from '@jucy-nakuru/config/clientConfig';
import { Configuration, Site, SitesApi } from '@jucy/rentals-api-client';

class RentalSitesApiClient extends SitesApi {
    constructor() {
        super(
            new Configuration({
                basePath: clientConfig.rentalsApi.baseUrl,
                middleware: [defaultHeadersMiddleware],
            })
        );
    }

    withToken(token: string | ((name?: string, scopes?: string[]) => string)): this {
        this.configuration = new Configuration({
            basePath: clientConfig.rentalsApi.baseUrl,
            accessToken: token,
        });
        return this;
    }

    async getAllSites(): Promise<Site[]> {
        const result = await cache.get(
            'rental-sites',
            () =>
                Promise.all(['au', 'nz'].map((countryCode) => rentalSitesApiClient.getSites(countryCode))).then((responses) =>
                    responses.reduce((acc, current) => [...acc, ...(current.data || [])], [] as Site[])
                ),
            CACHE_TTL.ONE_DAY
        );
        return result || [];
    }
}

const rentalSitesApiClient = new RentalSitesApiClient();
export default rentalSitesApiClient;
